import PrecioProducto from './PrecioProducto'

export default PrecioProducto
